import React from 'react'
import { CGE } from '../../../../common/components/CGE'

function RecoverPasswordFirstStep({props}) {
    
    return (
        <div>
            <CGE.Panel title={props?.title_get_password} description={props?.description_get_password}>
                <CGE.PanelSectionTicket >
                    <CGE.PanelContainer
                        alingItensCenter={true}
                        size="md">
                            <CGE.Spacing type="nl" />
                        <CGE.FormsField
                            handleChange={(e) => props?.setValues({ ...props?.values, rut: e.target.value })}
                            className="cge-form-element__input--width"
                            idFormElement="rut"
                            mandatoryElement={true}
                            horizontal={true}
                            labelName="Rut:"
                            labelStyle={{ fontSize: "14px"  }}
                            labelClass="cge-form-element__label-small"
                            hasError={props?.inputValidate?.empty?.rut || props?.inputValidate?.error?.rut}
                            msgError={props?.inputValidate?.msg?.rut}
                            value={props?.values?.rut}
                            typeElement="input-mask"
                            beforeMaskedValueChange={props?.beforeMaskedValueChangeRut}
                            formatChars={{
                                "9": "[0-9]",
                                k: "[Kk0-9]",
                            }}
                            mask="9.999.999-kk"
                        />
                        <CGE.FieldRecaptcha
                            onChange={props?.onChangeReCaptcha}
                            sitekey={props?.api_key_recaptcha}
                        />
                    </CGE.PanelContainer>
                </CGE.PanelSectionTicket>
                <div className="d-flex justify-content-between">
                    {/* <CGE.Button
                        label="¡Yo ya tengo un código!"
                        onClick={() => props?.setPage(1)}
                        type="ghost"
                    /> */}
                    <CGE.Button
                        label="Volver"
                        onClick={() => { window.history.back() }}
                        type="secondary"
                    />
                    <CGE.Button
                        label="Aceptar"
                        onClick={() => props?.handleClickFirstStep()}
                    />
                </div>
            </CGE.Panel>
        </div>
    )
}

export default RecoverPasswordFirstStep;